import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconMeter: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="meter">
    <path d="M11.4 4.223a7.8 7.8 0 0 0-4.475 1.854L8.348 7.5l-.848.849-1.423-1.424A7.8 7.8 0 0 0 4.223 11.4H6.6v1.2H4.223a7.799 7.799 0 0 0 1.854 4.475L7.5 15.652l.848.848-2.288 2.288-.424-.424a9 9 0 1 1 12.728 0l-.424.424L15.65 16.5l.849-.848 1.423 1.423a7.8 7.8 0 0 0 1.854-4.475H17.4v-1.2h2.377A7.8 7.8 0 0 0 12.6 4.223V6.6h-1.2V4.223Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 12a3 3 0 1 1-1.346-2.503L15.5 7.651l.849.849-1.846 1.845c.314.475.497 1.043.497 1.655Zm-1.2 0a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Z"
    />
    <path d="M14.6 18.4H9.4v1.2h5.2v-1.2Z" />
  </Icon>
);
